export enum SubscriptionStatusEnum {
  ACTIVE = 'active',
  EXPIRING = 'expiring',
  EXPIRED = 'expired'
}
